// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2YLuy","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__34u4y"};